import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_wd64rb2zkz_thi_007389e75d: FaireThemeEntity = {
  token: "board_demo_r_wd64rb2zkz_thi_007389e75d",
  type: "theme",
  retailerToken: "r_wd64rb2zkz",
  name: "Sip Local Shop Local Event Collection",
  description:
    "Curate a selection of handmade accessories and organic baby sets for local shoppers visiting downtown for the Sip Local, Shop Local event on April 25.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/dc71fd6087912515c9d48731945ab74ae7992e9918aa942e5069180674f27c60.png",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/dc71fd6087912515c9d48731945ab74ae7992e9918aa942e5069180674f27c60.png",
    "https://cdn.faire.com/fastly/c60a96d9c7963ff12fc0fae538445386e9ced95b3f32432a56188e633274423f.jpeg",
    "https://cdn.faire.com/fastly/dd0a7dd031b25a435429969f82ebd579978a7b769575dd3e1ab0cb5a3b1cd6e1.jpeg",
    "https://cdn.faire.com/fastly/4321390e4dbff2b6f9c27f243056012483ffdaec6e80d23c09e76e384333c2ed.jpeg",
    "https://cdn.faire.com/fastly/708fc27a0ec94da5a41f623afbb6356bbca93fbb84bcf82d3920d294dabfea59.jpeg",
    "https://cdn.faire.com/fastly/02243d28fbcb5733111a303223fe941124642cdb4dbef89650cdd10bc85783b5.jpeg",
  ],
  itemCount: 66,
  source: "eric_themes_ideas",
  teaser: "thi_007389e75d",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
